// extracted by mini-css-extract-plugin
export default {"container":"Container_container__7w2tH","fluid":"Container_fluid__S5SLE"};